export const LOAD_POSTS = 'resources/LOAD_POSTS';
export const LOAD_CATEGORIES = 'resources/LOAD_CATEGORIES';
export const LOAD_FEATURED_BLOG = 'resources/LOAD_FEATURED_BLOG';
export const SET_POSTS = 'resources/SET_POSTS';
export const SET_CATEGORIES = 'resources/SET_CATEGORIES';
export const SET_IS_LOADING = 'resources/SET_IS_LOADING';
export const SET_LOAD_MORE = 'resources/SET_LOAD_MORE';
export const SET_TOTAL_POSTS = 'resources/SET_TOTAL_POSTS';
export const SET_FEATURED_BLOG = 'resources/SET_FEATURED_BLOG';
export const RESET_POSTS = 'resources/RESET_POSTS';
export const RESET_CATEGORIES = 'resources/RESET_CATEGORIES';
